import React, { useEffect, useState } from "react";
import Meta from "../../helpers/meta";
import Nav from "../Nav";
import PromoSlider from "./PromoSlider";
import { Navigate, Link } from "react-router-dom";
import RestaurantList from "./RestaurantList";
import { connect } from "react-redux";
// import { getPromoSlides } from "../../../services/promoSlider/actions";
import { getSingleLanguageData } from "../../../services/languages/actions";
import { resetInfo, resetItems, resetBackup } from "../../../services/items/actions";
import withRouter from "../../../withRouter";
import GpsSelector from "../Location/PopularPlaces/GpsSelector";
import Ink from "react-ink";
import Dialog from "@mui/material/Dialog"


const Home = (props) => {
  const {
    user,
    promo_slides,
    getPromoSlides,
    getSingleLanguageData,
    resetItems,
    resetInfo,
    languages,
  } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    resetItems();
    resetInfo();
    resetBackup();

    if (localStorage.getItem("userSetAddress") !== null) {
      if (localStorage.getItem("showPromoSlider") === "true") {
        // getPromoSlides();
      }
    }

    
  }, [getPromoSlides, resetInfo, resetItems, user]);

  useEffect(() => {
    if (languages) {
      if (localStorage.getItem("userPreferedLanguage")) {
        getSingleLanguageData(localStorage.getItem("userPreferedLanguage"));
      } else if (languages.length) {
        const defaultLanguage = languages.find((lang) => lang.is_default === 1);
        if (defaultLanguage) {
          getSingleLanguageData(defaultLanguage.id);
        }
      }
    }
  }, []);

  const handlePopularLocationClick = (location) => {
		const userSetAddress = {
			lat: location.latitude,
			lng: location.longitude,
			address: location.name,
			house: null,
			tag: null,
			businessLocation: true,
		};
		localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));

		const saveUserSetAddress = new Promise((resolve) => {
			localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
			localStorage.setItem("userAlreadySelectedLocation", "true");
			resolve("Location Saved");
		});
		saveUserSetAddress.then(() => {
			window.location.reload();
		});
	};

  const toggleSchedulePopup = () => {
		setOpen(true);
	};

  if (window.innerWidth > 768) {
    return <Navigate to="/" />;
  }

  if (localStorage.getItem("userSetAddress") === null) {
    return <Navigate to="/search-location" />;
  }

  const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
  if (Object.keys(userSetAddress).length === 0 && userSetAddress.constructor === Object) {
    return <Navigate to="/my-location" />;
  }

  return (
    <React.Fragment>
      <Meta
        seotitle={localStorage.getItem("seoMetaTitle")}
        seodescription={localStorage.getItem("seoMetaDescription")}
        ogtype="website"
        ogtitle={localStorage.getItem("seoOgTitle")}
        ogdescription={localStorage.getItem("seoOgDescription")}
        ogurl={window.location.href}
        twittertitle={localStorage.getItem("seoTwitterTitle")}
        twitterdescription={localStorage.getItem("seoTwitterDescription")}
      />

      <div className="height-100-percent bg-white mb-50">
        <Nav
          logo={true}
          active_nearme={true}
          disable_back_button={true}
          history={props.history}
          loggedin={user.success}
        />

        {localStorage.getItem("showPromoSlider") === "true" && promo_slides?.mainSlides?.length > 0 && (
          <PromoSlider
            slides={promo_slides.mainSlides}
            size={promo_slides.mainSlides[0]["promo_slider"]["size"]}
          />
        )}

        {localStorage.getItem("mockSearchOnHomepage") === "true" && (
          <Link to="explore">
            <div
              className={`mock-search-block px-15 ${
                localStorage.getItem("showPromoSlider") === "false" ? "pt-15" : ""
              }`}
            >
              <div className="px-15 d-flex justify-content-between">
                <div>
                  <span>{localStorage.getItem("mockSearchPlaceholder")}</span>
                </div>
                <div>
                  <i className="si si-magnifier" />
                </div>
              </div>
            </div>
          </Link>
        )}

        {localStorage.getItem("customHomeMessage") &&
          !["<p><br></p>", "null", "<p style=\"text-align: right; \"><br></p>", ""].includes(localStorage.getItem("customHomeMessage")) && (
            <div
              style={{
                position: "relative",
                background: "#f8f9fa",
              }}
              dangerouslySetInnerHTML={{
                __html: localStorage.getItem("customHomeMessage"),
              }}
            />
          )}
        <RestaurantList user={user} slides={promo_slides.otherSlides} />
        <Dialog
					maxWidth={false}
					fullWidth={true}
					fullScreen={true}
					open={open}
					onClose={toggleSchedulePopup}
					style={{ margin: "auto", position: "absolute", bottom: "0", top: "60%" }}
					PaperProps={{
						style: {
							backgroundColor: "#fff",
							overflowY: "hidden",
						},
					}}
				>
					<div>
						<GpsSelector fetchGpsAutomaticallyAndroid={true} />
						<div className="p-15 popularLocationPopup">
							{props.popular_locations && props.popular_locations.length > 0 && (
								<React.Fragment>
									<h4 className="text-muted h4">{localStorage.getItem("searchPopularPlaces")}</h4>

									<div style={{ overflowY: "scroll", height: "11rem" }}>
										{props.popular_locations.map((location) => (
											<button
												key={location.id}
												type="button"
												className="btn btn-rounded btn-alt-secondary btn-md mb-15 mr-15"
												style={{
													position: "relative",
													backgroundColor:
														location.is_default && localStorage.getItem("storeColor"),
													color: location.is_default && "#fff",
												}}
												onClick={() => {
													handlePopularLocationClick(location);
												}}
											>
												<Ink duration="500" />
												{location.name}
											</button>
										))}
									</div>
								</React.Fragment>
							)}
						</div>
					</div>
				</Dialog>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  promo_slides: state.promo_slides.promo_slides,
  user: state.user.user,
  locations: state.locations.locations,
  languages: state.languages.languages,
  popular_locations: state.popular_locations.popular_locations,
});

export default withRouter(
  connect(mapStateToProps, {
    // getPromoSlides,
    getSingleLanguageData,
    resetInfo,
    resetItems,
    resetBackup,
  })(Home)
);
